// src/plugins/VueI18n/index.js：
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ja from './ja-JP'
import zh from './zh-CH'
Vue.use(VueI18n);
// 定义各语言的配置
const messages = {
  'zh-CN': zh, // 中文语言包
  'ja-JP': ja // 日文语言包

};

// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
  locale: 'ja-JP', // 设置默认地区
  messages, // 设置配置信息
});

export default i18n;



// WEBPACK FOOTER //
// ./src/locale/index.js